import React, { ReactNode } from "react";
import { CustomModal } from "src/components/Common/Modal/CustomModal";

export interface IFilterModalProps {
    children: ReactNode;
    show: boolean;
    enableClearFilter?: boolean,
    className?: string;
    cancelButtonName?: string;
    confirmButtonName?: string;
    additionalActionButtonName?: string;
    title?: string;
    onSubmit: () => void;
    onAdditionalButtonClick?: () => void;
    onHide: () => void;
    onCancelButtonClick?: () => void;
}

export const Drawer: React.FC<IFilterModalProps> = props => {
    return (
        <CustomModal
            className={`filter-modal-container ${props.className ?? ""}`}
            show={props.show}
            onHide={props.onHide}
            title={props.title}
            cancelButtonName={props.cancelButtonName}
            confirmButtonName={props.confirmButtonName}
            onSubmit={props.onSubmit}
            isConfirmModal={true}
            additionalActionButtonName={props.additionalActionButtonName}
            onAdditionalButtonClick={props.onAdditionalButtonClick}
            isConfirmButtonDisabled={!props.enableClearFilter}
            isAdditionalActionButtonDisabled={!props.enableClearFilter}
            
        >
            <div>{props.children}</div>
        </CustomModal>
    );
};
